const EventEmitter = require('events').EventEmitter
const eventEmitter = new EventEmitter()
import teras from '@/teras'
import it from './it'
import en from './en'
class tLang {
   constructor () {
      this.event = eventEmitter
      
      
   }

   change(lang){
      teras.save('lang',lang)
      teras.lang = lang
      teras.moment.locale(lang)
      this.event.emit('change',lang)
   }
   
   g(key) {
      return (teras.lang=='it') ? it[key] : en[key]
   }

}
export  default new tLang



// WEBPACK FOOTER //
// ./src/teras/tLang.js